import {
  Box,
  Button,
  HStack,
  Image,
  Text,
  VStack,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import AddIcon from "@mui/icons-material/Add";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Car from "../../../../../assets/images/car.svg";
import { CloseIcon } from "../../../../../components/icons/svg";
import { getSeparatorInUrlString } from "../../../../../utils";
import {
  deleteVehicle,
  fetchVehicles,
  getUrlForDetailsInSMS,
} from "../../../../../utils/api/vehicles";
import { useUserInfo } from "../../../../../utils/hooks/useUserInfo";
import Popup from "../../../../Charts/Popup";
import { Spinner } from "../../../../common";
import AddVehicleDrawer from "./AddVehicleDrawer/AddVehicleDrawer";

const Vehicles = (props: any) => {
  const { id } = props;
  const dealer = useUserInfo("dealership");
  const toast = useToast();
  const navigate = useNavigate();

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["fetchVehicles", id],
    queryFn: () => fetchVehicles(dealer?.id, id),
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess(data) {},
  });

  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [vId, setVId] = useState();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleOnClick = async (vId: any) => {
    try {
      const response = await getUrlForDetailsInSMS(dealer?.id, id, vId);
      if (response) {
        toast({
          description:
            response?.data?.message ?? "Vehicle Url shared successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "top",
        });
      }
    } catch (error: any) {
      console.error("Error:", error);
    }
  };
  const mutation = useMutation(deleteVehicle);

  const handleDelete = (vId: any) => {
    mutation.mutate(
      { dId: dealer?.id, id, vId },
      {
        onSuccess: () => {
          refetch();
          setIsOpenDelete(false);
          toast({
            description: "Vehicle deleted successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "top",
          });
        },
        onError: (error: any) => {
          toast({
            description: `Error deleting vehicle: ${
              error?.response?.data?.errors?.toString() ??
              "Something went wrong"
            }`,
            status: "error",
            duration: 5000,
            isClosable: true,
            position: "top",
          });
        },
      }
    );
  };

  const getImage = (urlString: string) => {
    if (!urlString) {
      return Car;
    }
    const separator = getSeparatorInUrlString(urlString);
    return separator ? urlString.split(separator)?.[0] : urlString;
  };

  //........................test obj.............
  //   {
  //     "id": 1454539,
  //     "make": "",
  //     "model": "",
  //     "year": null,
  //     "exterior_color": "",
  //     "interior_color": "",
  //     "mileage": null,
  //     "contact_id": 2748013,
  //     "preferred": true,
  //     "contact": {
  //         "id": 2748013,
  //         "first_name": "Stephen",
  //         "last_name": "Tannock",
  //         "email": "stevemikt@icloud.com",
  //         "phone_number": "(203) 823-2960",
  //         "work_number": null,
  //         "home_number": null,
  //         "middle_name": null,
  //         "prefix": null,
  //         "nick_name": null,
  //         "use_nick_name": false,
  //         "assign_person": {
  //             "sales_person": {
  //                 "id": null,
  //                 "name": null,
  //                 "join_date": null,
  //                 "phone_number": ""
  //             },
  //             "manager": {
  //                 "id": null,
  //                 "name": null,
  //                 "join_date": null,
  //                 "phone_number": ""
  //             },
  //             "bdc_agent": {
  //                 "id": null,
  //                 "name": null,
  //                 "join_date": null,
  //                 "phone_number": ""
  //             }
  //         },
  //         "dealership_address": "426 Derby Avenue, West Haven, CT 06516"
  //     },
  //     "inventory": {
  //         "id": 36446,
  //         "name": null,
  //         "vin": "1N4BL4DVXPN397068",
  //         "stock_number": "11410R",
  //         "new_or_used": "U",
  //         "year": 2023,
  //         "make": "Nissan",
  //         "model": "Altima",
  //         "model_number": "13313",
  //         "body": "4D Sedan",
  //         "color": "Gun Metallic",
  //         "odometer": 11571,
  //         "interior_color": "Charcoal",
  //         "msrp": null,
  //         "price": "22189.0",
  //         "description": "LOW MILES !!!!! New Price! * Local Trade, * One Owner, * Back-Up Camera, 17\" Machined Alloy Wheels, Blind Spot Warning, NissanConnect featuring Apple CarPlay and Android Auto, Power driver seat, Rear Parking Sensors, Remote keyless entry, Steering wheel mounted audio controls, Traction control.Gun Metallic 2023 Nissan Altima 2.5 SV 2.5L 4-Cylinder DOHC 16V CVT with Xtronic FWD 27/39 City/Highway MPGNissan Certified Details:  * Limited Warranty: 84 Month/100,000 Mile (whichever occurs first)  * 7 Year/100,000 Mile Limited Warranty, 24/7 Hour Roadside Assistance, Carfax Vehicle History Report, Plus 1 Year Pre-Paid Maintenance Included. Gas Powered Nissan Models Only.  * Vehicle History  * Transferable Warranty  * Roadside Assistance  * 167 Point Inspection  * Warranty Deductible: $100** 100,000 MILE WARRANTY INCLUDED ** CERTIFIED NISSAN comes with Extensive Protection: The Nissan Certified Pre-Owned Vehicle Limited Warranty covers 600 Components: Including Engine, transmission and drive train. Nissan CPO vehicle owner benefits include available LOW financing rates, 24-hour roadside assistance, trip interruption, car rental and towing. Buy with confidence, call today @ 866-860-4383 to schedule a test drive. This vehicle is ready for immediate delivery.",
  //         "features": "6 Speakers|AM/FM radio: SiriusXM|Radio data system|Radio: AM/FM Audio System|Air Conditioning|Rear window defroster|Power driver seat|Power steering|Power windows|Remote keyless entry|Steering wheel mounted audio controls|Four wheel independent suspension|Speed-sensing steering|Traction control|4-Wheel Disc Brakes|ABS brakes|Dual front impact airbags|Dual front side impact airbags|Front anti-roll bar|Knee airbag|Low tire pressure warning|Occupant sensing airbag|Overhead airbag|Rear anti-roll bar|Rear side impact airbag|Blind Spot Warning|Brake assist|Electronic Stability Control|Rear Parking Sensors|Auto High-beam Headlights|Delay-off headlights|Fully automatic headlights|Panic alarm|Security system|Speed control|Body-Colored Splash Guards|Bumpers: body-color|Chrome Bumper Protector|Power door mirrors|Cloth Seat Trim|Driver door bin|Driver vanity mirror|Floor Mats/Trunk Mat/Hideaway Net|Front reading lights|Illuminated entry|NissanConnect featuring Apple CarPlay and Android Auto|Outside temperature display|Overhead console|Passenger vanity mirror|Rear reading lights|Rear seat center armrest|Tachometer|Tech Spec Change|Telescoping steering wheel|Tilt steering wheel|Trip computer|Front Bucket Seats|Front Center Armrest|Split folding rear seat|Passenger door bin|Trunk Organizer Tray|17\" Machined Alloy Wheels|Alloy wheels|Speed-Sensitive Wipers|Variably intermittent wipers|* Local Trade|* One Owner|* Back-Up Camera",
  //         "photo_url_list": "https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/3d0f54c3-1472-4f6e-96b2-2eda3803772f.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/3b638c16-47a1-49ba-be3e-54dbd87e437f.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/68efe78f-fbf4-4dc5-93c6-7bbc7ea3243c.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/eb73ce62-0226-49d9-a03f-774fd9df35e4.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/4c23ead9-126a-473b-b521-e05bd7e0a2b4.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/2d5edad7-10cc-4d4c-bc05-e4b242bea7ea.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/eda45444-fb10-47a6-a2b2-331c86d1f883.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/904930c4-4431-40a5-895f-d2caa24056f3.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/d6e88e40-85b4-4b30-b7dc-474537d86e40.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/2bb62fe6-ce90-4806-bfc0-df7218a40bdf.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/5dada448-a4a1-4662-80a1-cf24e3b302da.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/92f35fa5-b534-4da3-b9ff-60117e13bf34.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/4e671256-16ce-4718-b984-7fa804d67692.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/4344614c-198b-41c3-9ba8-611a5524cbe1.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/ffcc2d64-ce4e-460d-83e8-39813d0bf36b.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/a4a67e4b-466d-41e1-a6fb-767eb0cc0878.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/2f5376f3-cbee-4164-ac2e-e34b38b1b18c.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/8d5a1694-6733-440d-8d71-6c999e352bc1.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/d2df2fbc-a930-46e2-b59f-212360c30de1.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/d3be494f-8de4-4d66-856b-29714e0b8c23.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/500cac20-dcf3-4a7c-ac63-55e0c8071452.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/1576e5f6-6a02-4194-93ac-38cc1feba601.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/b606834c-e33c-4b42-b772-957fc7a4f4c9.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/12c89fb9-8cb4-494b-abd8-b1803178686c.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/15d532f9-a23e-472b-8d5d-b14a8b9b72c4.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/fa5f0860-4866-4e1a-a0e8-95178e8c66de.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/5eb9223e-2495-406d-ab06-60641810027b.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/47740de9-6939-4162-8860-307eb74e4ce0.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/1dc5fcde-7308-4ddc-8582-765c451f1809.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/a49ddbba-dcf5-4a6a-a70e-8e4ff8530b8f.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/3d98da22-6eae-45fc-aada-d75e1902438e.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/af4aa634-dd27-41f3-983b-cccc21eed303.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/364dc350-e8d9-47b5-812c-4e4e5ae74b43.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/ad16f19b-05dd-4620-9fe1-9250d36a1991.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/4e31ba32-413d-49e6-a38e-c600f54699e8.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/9e9e5d21-9143-451f-85a3-f9cad30ae263.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/0c8ea243-ff15-4f6d-b62e-f28fcdb29f32.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/a8f80901-0590-401b-978e-14fe641f06fa.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/7a65e64f-5f97-4c45-8fd1-c3451832c51e.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/788755c2-f4fa-4ce3-b9b1-65b219894444.jpg|https://assets.cai-media-management.com/resize/1024x1024/common-vehicle-media/2d8e47e9-8838-4c51-ae67-8be889d5e02c.jpg",
  //         "dealership_id": 167,
  //         "status": "available",
  //         "uploaded_images": ""
  //     }
  // }

  return (
    <VStack
      h="100%"
      background="var(--grey-50)"
      padding="1rem"
      gap="1rem"
      alignItems="flex-end"
      w="100%"
    >
      <VStack
        background="white"
        borderRadius="0.5rem"
        border="1px solid var(--grey-300)"
        padding="1rem"
        alignItems="flex-start"
        // gap="1rem"
        h="calc(100vh - 130px)"
        overflow="auto"
        w="100%"
      >
        <HStack
          w="100%"
          justifyContent="space-between"
          pb="1rem"
          borderBottom="1px solid var(--grey-300)"
        >
          <HStack>
            <Text textStyle="h4" fontWeight="500">
              Vehicles
            </Text>
            <Text textStyle="h4" fontWeight="500" color="var(--grey-500)">
              ({data?.data?.vehicles_count})
            </Text>
          </HStack>
          <HStack>
            <Button
              variant="outline"
              padding="0.5rem"
              minW="auto"
              onClick={onOpen}
            >
              <AddIcon
                style={{
                  color: "var(--grey-700)",
                  fontSize: "1.5rem",
                }}
              />
            </Button>
          </HStack>
        </HStack>
        <VStack gap="1rem" alignItems="flex-start" w="100%" mt="1rem">
          {data?.data?.vehicles?.map((item: any) => (
            <HStack
              key={item.id}
              w="100%"
              padding="1rem"
              borderRadius="0.5rem"
              border="1px solid var(--grey-300)"
              alignItems="flex-start"
              gap="1rem"
              position="relative"
              onClick={() => setVId(item.id)}
            >
              <VStack gap="0.5rem" mb="1rem" w="35%">
                <Image
                  src={getImage(
                    item?.inventory?.uploaded_images?.trim() ||
                      item?.inventory?.photo_url_list?.trim() ||
                      ""
                  )}
                  width={200}
                  height={150}
                  objectFit="cover"
                  alt="car Image"
                  style={{
                    borderRadius: "0.5rem",
                  }}
                />
              </VStack>
              <VStack alignItems="flex-start" gap="0.5rem" w="65%">
                <VStack
                  alignItems="flex-start"
                  w="100%"
                  gap="0.25rem"
                  pb="0.5rem"
                  borderBottom="1px solid var(--grey-300)"
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <HStack paddingRight="1rem">
                      {item?.preferred && (
                        <Text
                          textStyle="captionSmall"
                          fontWeight="500"
                          background="var(--flame-100)"
                          color="var(--flame-600)"
                          padding="0.25rem 0.75rem"
                          borderRadius="200rem"
                          mb="0.25rem"
                        >
                          Preferred
                        </Text>
                      )}
                      {item?.inventory?.status === "available" && (
                        <Text
                          textStyle="captionSmall"
                          fontWeight="500"
                          color="#12c607"
                          background="#d8f3d8"
                          padding="0.25rem 0.75rem"
                          borderRadius="200rem"
                          mb="0.25rem"
                        >
                          Available
                        </Text>
                      )}
                      {item?.inventory?.status === "unavailable" && (
                        <Text
                          textStyle="captionSmall"
                          fontWeight="500"
                          background="var(--flame-100)"
                          color="var(--flame-600)"
                          padding="0.25rem 0.75rem"
                          borderRadius="200rem"
                          mb="0.25rem"
                        >
                          Not Available
                        </Text>
                      )}
                    </HStack>
                  </Box>

                  {!item?.inventory && (
                    <Text textStyle="h4" fontWeight="500">
                      {item.year} {item.make} - {item.model}
                    </Text>
                  )}
                  {item?.inventory && (
                    <Text textStyle="h4" fontWeight="500">
                      {item.inventory.year} {item.inventory.make} -{" "}
                      {item.inventory.model}
                    </Text>
                  )}
                  <HStack
                    alignItems="flex-end"
                    justifyContent="space-between"
                    w="100%"
                  >
                    <VStack alignItems="flex-start" gap="0">
                      <Text
                        textStyle="captionSmall"
                        fontWeight="500"
                        color="var(--grey-500)"
                      >
                        Exterior Color:{" "}
                        {item?.inventory
                          ? item?.inventory?.color
                          : item.exterior_color}
                      </Text>
                      <Text
                        textStyle="captionSmall"
                        fontWeight="500"
                        color="var(--grey-500)"
                      >
                        Interior Color:{" "}
                        {item?.inventory
                          ? item?.inventory?.interior_color
                          : item.interior_color}
                      </Text>
                      <Text
                        textStyle="captionSmall"
                        fontWeight="500"
                        color="var(--grey-500)"
                      >
                        Mileage:{" "}
                        {item?.inventory?.odometer ?? item?.mileage ?? "-"}
                      </Text>
                      {item?.inventory && (
                        <>
                          <Text
                            textStyle="captionSmall"
                            fontWeight="500"
                            color="var(--grey-500)"
                          >
                            VIN: {item?.inventory?.vin}
                          </Text>
                          <Text
                            textStyle="captionSmall"
                            fontWeight="500"
                            color="var(--grey-500)"
                          >
                            Stock #: {item?.inventory?.stock_number}
                          </Text>
                          {item?.inventory?.price && (
                            <Text
                              textStyle="captionSmall"
                              fontWeight="500"
                              color="var(--grey-500)"
                            >
                              Price: USD {item?.inventory?.price}
                            </Text>
                          )}
                        </>
                      )}
                    </VStack>
                    <Button
                      variant="outline"
                      mb="0.25rem"
                      onClick={() =>
                        navigate(`/vehicle?slug=${item.id}&id=${id}`)
                      }
                    >
                      View Details
                    </Button>
                  </HStack>
                </VStack>
                {/* <Button
                  variant="outline"
                  padding="0.37rem 0.44rem"
                  minW="auto"
                  h="auto"
                  onClick={(event) => handleOnClick(item.id)}
                >
                  <SendIcon />
                </Button> */}
              </VStack>
              <Button
                variant="none"
                border="1px solid var(--grey-300)"
                position="absolute"
                right="0.5rem"
                top="0.5rem"
                padding="0.15rem"
                borderRadius="0.5rem"
                onClick={() => {
                  setIsOpenDelete(true);
                }}
                sx={{
                  svg: {
                    w: "1rem",
                    h: "1rem",
                    path: {
                      fill: "var(--grey-900)",
                    },
                  },
                }}
              >
                <CloseIcon />
              </Button>
            </HStack>
          ))}
        </VStack>
      </VStack>

      {isOpen && (
        <AddVehicleDrawer
          isOpen={true}
          onClose={() => {
            onClose();
            refetch();
          }}
          info={{ dId: dealer?.id, id: id }}
        />
      )}

      {isOpenDelete && (
        <Popup
          isOpen={true}
          onClose={() => setIsOpenDelete(false)}
          onConfirm={() => handleDelete(vId)}
          title="Delete Confirmation"
          message="Are you sure you want to delete this vehicle?"
        />
      )}
      {isFetching && <Spinner />}
    </VStack>
  );
};

export default Vehicles;
